<div class="main medication-list">
    <div class="title-btn">
        <div class="main-title">
            <h1>Forecast</h1>
        </div>
    </div>
    <form [formGroup]="forecastForm" (ngSubmit)="onSubmit()">
        <select class="form-control" formControlName="sensor">
            <option *ngFor="let sensor of farmHouseSensorsList" [value]="sensor.deviceId">
                {{ sensor.sensorName }}
            </option>
        </select>
        <div class="mt-4">
            <!-- <button type="submit" class="btn btn-primary">Submit</button> -->
            <button class="btn btn-primary" type="submit" [disabled]="isLoading$ | async">
                <span *ngIf="!isAuthLoading">Submit</span>
                <span *ngIf="isAuthLoading">Submitting...</span>
            </button>
            <img *ngIf="isLoading$ | async" src="assets/img/loader.gif" alt="Loading..." class="loader-image mt-2">
        </div>
    </form>

    <div class="mt-5">
        <h3>Forecast Data</h3>
        <div *ngIf="error; else predictionBlock">
            <p style="color: red;">{{ error }}</p>
          </div>
          <ng-template #predictionBlock>
            <ul class="list-data">
                <li *ngFor="let value of forecastData">{{ value }}</li>
            </ul>
          </ng-template>
        <!-- <ul class="list-data"> -->            
        <!-- </ul> -->
    </div>
</div>